import tacHelpers from '../../state/tac/tacHelpers';
import { range } from '../../state/tac/range';
import {
  selectCombinedAvailableColors,
  selectFiltersWithColorOptions,
} from '../../state/productMenu/productMenuSelectors';
import { actionSetSelectableColors } from '../../state/productMenu/productMenuActions';

export function hasRoomSlots(tac, space, item, extraFilter) {
  const itemSpace = tacHelpers.getSpaceForItem(space, item);
  const dependentItems = range.getDependentItems(item, tac);
  const fittingTac = tacHelpers.filterTac(
    tac,
    dependentItems.map(item => item.itemid)
  );
  const rects = tacHelpers.getRects(fittingTac, item, tac);
  const roomSlots = tacHelpers.getRoomSlots(itemSpace, rects, item, item, tac);

  if (extraFilter) {
    return roomSlots.filter(extraFilter).length;
  }
  return roomSlots.length;
}

export const thunkSetSelectableColors = () => (dispatch, getState) => {
  const filters = selectFiltersWithColorOptions(getState());

  filters.forEach(({ name: filterName }) => {
    const availableColors = selectCombinedAvailableColors(
      getState(),
      filterName
    );
    dispatch(actionSetSelectableColors(availableColors, filterName));
  });
};
